<template>
	<span>
		<b-form-radio
			v-for="(option, i) in options"
			:key="name + '--' + i"
			v-model="selected"
			:name="name"
			:value="option.value"
			:disabled="disabled"
			:inline="!stacked"
			@change="$emit('change', $event)"
			@input="$emit('input', $event)"
		>
			{{ option.text }}
			<span v-if="option.info" v-b-tooltip :title="option.info" class="ml-1 correct-icon-top-1px">
				<Icon icon="info"/>
			</span>
		</b-form-radio>
	</span>
</template>

<script>
import {uuid} from "vue-uuid";
import Icon from "@/vue/icon/Icon.vue";

export default {
	components: {Icon},

	props: {
		value: {
			required: false,
		},
		options: {
			type: Array,
			required: true,
		},
		stacked: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		return {
			selected: this.value,
			name: 'radio-group-' + uuid.v4(),
		};
	},

	watch: {
		value (v)
		{
			if (v !== this.selected)
			{
				this.selected = v;
			}
		}
	}
}
</script>
